import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentIncidentById } from 'actions/diceActions';
import { useNavigate } from 'react-router';
import { fetchIncidentsForGroup } from 'actions/roleActions';
import LegacyPratusTable from 'components/DesignSystems/PratusTable/LegacyPratusTable';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { UpgradeHoverLock } from 'components/Notifications/LockedUpgradeOption';
import { useHubOnlyFlag } from 'utils/featureFlags';

export default function GroupIncidents() {
  const navigate = useNavigate();
  const hubOnly = useHubOnlyFlag();
  const reduxDispatch = useDispatch();

  const reduxIncidentsForGroup = useSelector((state) => {
    const incidents = state.app.incidentsForGroup;
    return incidents;
  });

  const reduxCurrentlySelectedGroup = useSelector((state) => {
    return state.app.currentlySelectedGroup;
  });

  useEffect(() => {
    if (reduxCurrentlySelectedGroup) {
      reduxDispatch(
        fetchIncidentsForGroup(reduxCurrentlySelectedGroup.group_guid)
      );
    }
  }, [reduxCurrentlySelectedGroup]);

  const columns = [
    {
      dataField: 'name',
      text: 'Name',
      sort: true,
      headerAttrs: { title: 'Sort By:' },
      attrs: { title: 'Name' },
    },
    {
      dataField: 'types',
      text: 'Type',
      sort: true,
      attrs: { title: 'Type' },
    },
  ];

  const handleIncidentLinkClick = (incidentId) => {
    reduxDispatch(updateCurrentIncidentById(incidentId));
    navigate(`/iap/${incidentId}/settings`);
  };

  const expandRow = {
    parentClassName: 'parent-expand-tr',
    className: 'child-expand-tr',
    renderer: (row) => {
      return (
        <>
          <StylishNewButton
            className="button--primary w-md-auto w-100"
            type="button"
            onClick={() => handleIncidentLinkClick(row.incident_id)}
          >
            Configure Incident
          </StylishNewButton>
        </>
      );
    },
    showExpandColumn: true,
  };

  return (
    <>
      <div className="d-md-flex align-items-center mb-3">
        <h4 className="m-0">Organization Incidents</h4>
        <span className="tw:inline-flex ms-auto">
          <UpgradeHoverLock locked={hubOnly}>
            <StylishNewButton
              className="button--primary mt-md-0 mt-2"
              onClick={() => navigate('/create/incident')}
            >
              New Incident
            </StylishNewButton>
          </UpgradeHoverLock>
        </span>
      </div>
      <div className="form-block">
        <LegacyPratusTable
          keyField={'incident_id'}
          columns={columns}
          rows={
            reduxIncidentsForGroup && !!reduxIncidentsForGroup.length
              ? reduxIncidentsForGroup.map((rig) => ({
                  ...rig,
                  types: rig?.incident_types?.join(', '),
                }))
              : []
          }
          expandRow={expandRow}
        />
      </div>
    </>
  );
}
